// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"310":"600c9a0a","848":"e164842d"}[chunkId] + ".js";
};